import type React from 'react';
import type { JSX } from 'react';

import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export const BaseFontFeatureSettings = "'case' on, 'ss04' on";
export const NumberFontFeatureSettings = "'tnum' on, 'lnum' on, 'case' on";

interface TextLinkProps extends React.HTMLAttributes<HTMLSpanElement> {
    children: React.ReactNode;
    color?: string;
    className?: string;
    href?: string;
    newTab?: boolean;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const makeTextLinkElement =
    (twClasses: string) =>
    ({
        children,
        href = undefined,
        onClick,
        newTab,
        color = 'inherit',
        className,
        ...props
    }: TextLinkProps): JSX.Element => {
        const combinedClassName = twMerge(clsx(twClasses, className));
        const style: React.CSSProperties = { color };

        return href === '' ? (
            <span
                onClick={onClick}
                style={{ ...style, cursor: !!onClick ? 'pointer' : undefined }}
                className={combinedClassName}
                {...props}
            >
                {children}
            </span>
        ) : (
            <a
                href={href}
                style={{ ...style, cursor: 'pointer' }}
                className={combinedClassName}
                {...(newTab ? { target: '_blank', rel: 'noopener noreferrer' } : undefined)}
                onClick={onClick}
                {...props}
            >
                {children}
            </a>
        );
    };

export default {
    Link: {
        x10: makeTextLinkElement('text-[0.6875rem] leading-[1.125rem] font-normal tracking-[0.006875rem] underline'), // 11px/18px
        x20: makeTextLinkElement('text-[0.8125rem] leading-[1.25rem] font-normal tracking-[0.008125rem] underline'), // 13px/20px
        x30: makeTextLinkElement('text-[0.9375rem] leading-[1.5rem] font-normal tracking-[0.009375rem] underline'), // 15px/24px
    },
};
